import { render, staticRenderFns } from "./DeliverVehicle.vue?vue&type=template&id=7b334f8b&scoped=true"
import script from "./DeliverVehicle.vue?vue&type=script&lang=js"
export * from "./DeliverVehicle.vue?vue&type=script&lang=js"
import style0 from "./DeliverVehicle.vue?vue&type=style&index=0&id=7b334f8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b334f8b",
  null
  
)

export default component.exports